import { useTranslation } from 'react-i18next';

import { IncidentOperationProgress } from '@/features/shared/IncidentOperationProgress';
import { NgButton, PanelErrorWithIcon } from '@/ui';
import { LoadingRetryButton } from '@/ui/loading/LoadingRetryButton';

import type { IncidentCreationStatus } from './useCreateIncident';

export function IncidentCreationFeedback({
  status,
  compact = false,
  onRetry,
  onCancel,
}: {
  status: IncidentCreationStatus;
  compact?: boolean;
  onRetry?: () => void;
  onCancel?: () => void;
}) {
  const { t } = useTranslation();

  if (status === 'pending') return <IncidentOperationProgress operation="incident" compact={compact} />;
  if (status === 'idle') return null;

  return (
    <div role="alert" className="p-3 operation-feedback">
      <PanelErrorWithIcon title={t('Global_ActionFailed')} centerContent />
      {onRetry && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <LoadingRetryButton onRetry={onRetry} />
          <NgButton text={t('Button_Cancel')} outline onClick={onCancel} />
        </div>
      )}
    </div>
  );
}
